<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>ROI分布 (计算方式:ltv / 用户成本 * 100)</span>
    </div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="国家" prop="startDate">
        <el-select v-model="queryParams.country" filterable placeholder="请选择">
          <el-option
            v-for="item in country"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-download" :loading="loading" size="mini" @click="exportData()">导出</el-button>
      </el-form-item>
    </el-form>

    <div ref="chartContainer" style="width: 100%; height: 400px;;margin-bottom: 20px" />

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="日期"
        width="100px"
        align="center"
      />
      <el-table-column
        prop="reg_count"
        label="新增"
        align="center"
      />
      <el-table-column
        prop="ltv_record.0.roi"
        label="当日"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.1.roi"
        label="ROI1"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.2.roi"
        label="ROI2"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.3.roi"
        label="ROI3"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.4.roi"
        label="ROI4"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.5.roi"
        label="ROI5"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.6.roi"
        label="ROI6"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.7.roi"
        label="ROI7"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.8.roi"
        label="ROI15"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.9.roi"
        label="ROI30"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.10.roi"
        label="ROI60"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="ltv_record.11.roi"
        label="ROI90"
        align="center"
        :formatter="numFormatter"
      />
    </el-table>

  </el-card>
</template>

<script>
import { getLtvData } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { getCacheQuery, setCacheQuery } from '@/utils'

export default {
  name: 'DatatStatRoi',
  data() {
    return {
      country: [],
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        type: 0
      },
      loading: false,
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables(undefined)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.type = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getLtvData(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        if (res.code === 200) {
          // this.tableData = res.data.r
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const data = res.data.data.Result
          const country = res.data.data.Country
          this.country = [{ value: '', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: i, label: country[i] })
          }
          const ltvData = {}
          for (let i = 0; i <= 11; i++) {
            ltvData[i] = []
          }
          this.date = []
          for (const k in data) {
            const val = data[k]
            this.date.push(val.date)
            for (const i in val.ltv_record) {
              const record = val.ltv_record[i]
              const _i = parseInt(i)
              if (ltvData[_i]) {
                ltvData[_i].push(record.roi)
              }
            }
          }

          for (const i in ltvData) {
            if (this.option.series[i]) {
              this.option.series[i].data = ltvData[i]
            }
          }
          this.option.xAxis.data = this.date
          this.chart.setOption(this.option)

          // console.log('tableData', data)
          this.tableData = data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          // text: '新增留存'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['ROI当天', 'ROI1', 'ROI2', 'ROI3', 'ROI4', 'ROI5', 'ROI6', 'ROI7', 'ROI15', 'ROI30'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: 'ROI当天',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI1',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI2',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI3',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }, {
            name: 'ROI4',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI5',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI6',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI7',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }, {
            name: 'ROI15',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI30',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'ROI60',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }, {
            name: 'ROI90',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    exportData(typ) {
      this.loading = true
      this.queryParams.type = 1
      getLtvData(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
